import _ from "lodash"
import fetch from "cross-fetch";
import {domain, quoterurl, GETMAKE, GETMODEL,GETCAR, GETPOSTAL,CRMURL,DEV} from '../../app/settings'
import {setField,setOptions,setEnabled} from './fieldsSlice'
import { setContactButton, setEntutiveLogoShow, setProfile } from "../ui/uiSlice";
import LogRocket from "logrocket";

const fieldsMiddleware = {
    yearMiddleware : (data,state,dispatch) => {
        return new Promise((resolve)=>{

            var objectIndex = _.chain(data.path).split(".").dropRight().value();
            objectIndex = objectIndex[objectIndex.length-1];
            
            if(parseInt(objectIndex) === 0){
                var propertyName = _.get(state.fields,`${_.chain(data.path)}.propertyName`,false);
                recordIntoCRM(propertyName,data.value,{id:state.fields.user.crmi.value,guid:state.fields.user.guid.value},dispatch);
            }

            dispatch(setOptions({field:`${_.chain(data.path).split(".").dropRight().join(".").value()}.manu`,options:[]}))
            dispatch(setOptions({field:`${_.chain(data.path).split(".").dropRight().join(".").value()}.vicc`,options:[]}))
            dispatch(setOptions({field:`${_.chain(data.path).split(".").dropRight().join(".").value()}.vice`,options:[]}))
            dispatch(setOptions({field:`${_.chain(data.path).split(".").dropRight().join(".").value()}.mkmd`,options:[]}))

            dispatch(setField({field:`${_.chain(data.path).split(".").dropRight().join(".").value()}.manu`,value:""}))
            dispatch(setField({field:`${_.chain(data.path).split(".").dropRight().join(".").value()}.vicc`,value:""}))
            dispatch(setField({field:`${_.chain(data.path).split(".").dropRight().join(".").value()}.vice`,value:""}))
            dispatch(setField({field:`${_.chain(data.path).split(".").dropRight().join(".").value()}.mkmd`,value:""}))

            dispatch(setEnabled({field:`${_.chain(data.path).split(".").dropRight().join(".").value()}.mkmd`,enabled:false}))
            dispatch(setEnabled({field:`${_.chain(data.path).split(".").dropRight().join(".").value()}.manu`,enabled:false}))

            fetch(`${domain+quoterurl+GETMAKE}?${new URLSearchParams({year:data.value})}`,{method:"GET",headers: {'Content-Type': 'application/json; charset=utf-8'}})
            .then((response) => response.json())
            .then((makes) => {
                dispatch(setOptions({field:`${_.chain(data.path).split(".").dropRight().join(".").value()}.manu`,options:_.map(makes,(o)=>{return {name:o.manufac,value:o.manufac}})}))
                dispatch(setEnabled({field:`${_.chain(data.path).split(".").dropRight().join(".").value()}.manu`,enabled:true}))
                resolve(data.value);
            });
            
        });
    },
    manuMiddleware : (data,state,dispatch) => {
        return new Promise((resolve)=>{

            
            var objectIndex = _.chain(data.path).split(".").dropRight().value();
            objectIndex = objectIndex[objectIndex.length-1];
            
            if(parseInt(objectIndex) === 0){
                var propertyName = _.get(state.fields,`${_.chain(data.path)}.propertyName`,false);
                recordIntoCRM(propertyName,data.value,{id:state.fields.user.crmi.value,guid:state.fields.user.guid.value},dispatch);
            }

            dispatch(setOptions({field:`${_.chain(data.path).split(".").dropRight().join(".").value()}.vicc`,options:[]}))
            dispatch(setOptions({field:`${_.chain(data.path).split(".").dropRight().join(".").value()}.vice`,options:[]}))
            dispatch(setOptions({field:`${_.chain(data.path).split(".").dropRight().join(".").value()}.mkmd`,options:[]}))
            dispatch(setField({field:`${_.chain(data.path).split(".").dropRight().join(".").value()}.vicc`,value:""}))
            dispatch(setField({field:`${_.chain(data.path).split(".").dropRight().join(".").value()}.vice`,value:""}))
            dispatch(setEnabled({field:`${_.chain(data.path).split(".").dropRight().join(".").value()}.mkmd`,enabled:false}))

            var year = _.get(state.fields,`${_.chain(data.path).split(".").dropRight().join(".").value()}.year.value`,false);
            
            fetch(`${domain+quoterurl+GETMODEL}?${new URLSearchParams({year:year,car:data.value})}`,{method:"GET",headers: {'Content-Type': 'application/json; charset=utf-8'}})
            .then((response) => response.json())
            .then((models)=>{
                const modelslist = [];
                const vicc = [];
                const vicc_ext = [];
    
                for (let i = 0; i < models.length; i++) {
                    modelslist.push({name:models[i].models,value:models[i].models});
                    vicc.push({name:models[i].models,value:models[i].vicc});
                    vicc_ext.push({name:models[i].models,value:models[i].vicc_ext});
                }
    
                dispatch(setOptions({field:`${_.chain(data.path).split(".").dropRight().join(".").value()}.vicc`,options:vicc}))
                dispatch(setOptions({field:`${_.chain(data.path).split(".").dropRight().join(".").value()}.vice`,options:vicc_ext}))
                dispatch(setOptions({field:`${_.chain(data.path).split(".").dropRight().join(".").value()}.mkmd`,options:modelslist}))
                dispatch(setEnabled({field:`${_.chain(data.path).split(".").dropRight().join(".").value()}.mkmd`,enabled:true}))
                
                resolve(data.value);
            });

           
        });
        
    },
    mkmdMiddleware : (data,state,dispatch) => {
        return new Promise((resolve)=>{

            var objectIndex = _.chain(data.path).split(".").dropRight().value();
            objectIndex = objectIndex[objectIndex.length-1];
            
            if(parseInt(objectIndex) === 0){
                var propertyName = _.get(state.fields,`${_.chain(data.path)}.propertyName`,false);
                recordIntoCRM(propertyName,data.value,{id:state.fields.user.crmi.value,guid:state.fields.user.guid.value},dispatch);
            }
            var year = _.get(state.fields,`${_.chain(data.path).split(".").dropRight().join(".").value()}.year.value`,false);
            var viccOptions = _.get(state.fields,`${_.chain(data.path).split(".").dropRight().join(".").value()}.vicc.options`,false);
            var viceOptions = _.get(state.fields,`${_.chain(data.path).split(".").dropRight().join(".").value()}.vice.options`,false);
    
            var viccValue = _.find(viccOptions,['name',data.value]).value;
            var viceValue = _.find(viceOptions,['name',data.value]).value;
    
            fetch(`${domain+quoterurl+GETCAR}?${new URLSearchParams({vicc:viccValue,viccext:viceValue,year:year})}`,{method:"GET",headers: {'Content-Type': 'application/json; charset=utf-8'}})
            .then((response) => response.json())
            .then((car)=>{

                dispatch(setField({field:`${_.chain(data.path).split(".").dropRight().join(".").value()}.bdty`,value:car[0].bodytype}))
                dispatch(setField({field:`${_.chain(data.path).split(".").dropRight().join(".").value()}.flTy`,value:car[0].fueltype}))
                dispatch(setField({field:`${_.chain(data.path).split(".").dropRight().join(".").value()}.hybd`,value:car[0].hybrid}))
                dispatch(setField({field:`${_.chain(data.path).split(".").dropRight().join(".").value()}.ncyl`,value:car[0].cylinder}))
                dispatch(setField({field:`${_.chain(data.path).split(".").dropRight().join(".").value()}.vnew`,value:car[0].price}))
                
                dispatch(setField({field:`${_.chain(data.path).split(".").dropRight().join(".").value()}.vicc`,value:viccValue}))
                dispatch(setField({field:`${_.chain(data.path).split(".").dropRight().join(".").value()}.vice`,value:viceValue}))
                
                resolve(data.value);
            });
            
            
            
        });
        

    },
    postMiddleware : (data,state,dispatch) => {
        return new Promise((resolve) => {
            
            var propertyName = _.get(state.fields,`${_.chain(data.path)}.propertyName`,false);
            recordIntoCRM(propertyName,data.value,{id:state.fields.user.crmi.value,guid:state.fields.user.guid.value},dispatch);


            data.value = data.value.trim();
            data.value = data.value.toUpperCase();
            if(data.value.length === 6){
                fetch(`${domain+quoterurl+GETPOSTAL}?${new URLSearchParams({fsa:data.value.slice(0,3),lcr:data.value.slice(-3)})}`,{method:"GET",headers: {'Content-Type': 'application/json; charset=utf-8'}})
                .then((response) => response.json())
                .then((location)=>{
                    dispatch(setField({field:"user.loca",value:location[0].city}))
                    dispatch(setField({field:"user.loin",value:location[0].code}))
                    resolve(data.value);
                });
            }else{
                dispatch(setField({field:"user.loca",value:""}))
                dispatch(setField({field:"user.loin",value:""}))
                resolve(data.value)
            }
        });
    },
    crmRecordMiddleware: (data,state,dispatch) => {
        return new Promise((resolve) => {
            var objectIndex = _.chain(data.path).split(".").dropRight().value();
            objectIndex = objectIndex[objectIndex.length-1];
            
            if(!isNaN(objectIndex)){
                if(parseInt(objectIndex) !== 0){
                    resolve(data.value);
                    return;
                }
            }
            var propertyName = _.get(state.fields,`${_.chain(data.path)}.propertyName`,false);
            recordIntoCRM(propertyName,data.value,{id:state.fields.user.crmi.value,guid:state.fields.user.guid.value},dispatch);
            resolve(data.value)
        });
    },
    checkoutVersion: (data,state,dispatch) =>{
        return new Promise((resolve)=>{

            if (data.value === "MIBF2"){
                dispatch(setEntutiveLogoShow({show:true}))
                dispatch(setContactButton({button:"CALL",phoneNumber:"18338692642"}))
                dispatch(setProfile({profile:"Entuitive"}))
            }
            
            recordIntoCRM("lead_account",data.value,{id:state.fields.user.crmi.value,guid:state.fields.user.guid.value},dispatch);
            resolve(data.value)
        })
    }
    // activateCommercial: (data,state,dispatch) => {
    //     return Promise((resolve) => {
            
    //         dispatch(setField({field:`drivs.model.drli.type`,value:"hidden"}))
    //         dispatch(setField({field:`drivs.model.cdrl.type`,value:"select"}))
            
    //         resolve(data.value)
    //     })
    // }
}
function checkCRMForEmailDuplicateAndMerge(email,clientid,dispatch){
    var formdata = new FormData();
    formdata.append("verifyEmail", "true");
    formdata.append("email", email);
    formdata.append("id", clientid);

    var requestOptions = {
        method: 'POST',
        body: formdata,
        redirect: 'follow'
    };

    fetch(`${domain+quoterurl+CRMURL}`,requestOptions)
    .then(response => response.json())
    .then(result => {
        if(result.available === "true"){
            dispatch(setField({field:"user.crmi",value:result.newid}))
        }
        var _hsq = window._hsq = window._hsq || []; 
        _hsq.push(['identify', { email:email }]);
        _hsq.push(['trackPageView']);
        LogRocket.identify(email, {
            h_id: clientid,
            email: email
        });
    });
}
function recordIntoCRM(property,value,clientid,dispatch){
    if(!DEV){   
        if(clientid.id.length > 0){

            if(property == "email"){
                checkCRMForEmailDuplicateAndMerge(value,clientid.id,dispatch)
                return;
            }

            var formdata = new FormData();
            formdata.append("id", clientid.id);
            formdata.append("props", `{"${property}":"${value}"}`);

            var requestOptions = {
                method: 'POST',
                body: formdata,
                redirect: 'follow'
            };


            fetch(`${domain+quoterurl+CRMURL}`,requestOptions)
                    .then((response) => response.text())
                    .then((res)=>{
                });

        }else{
            var formdata = new FormData();
            var utmdata = "";
            var element = document.querySelector("body");
            var attrs = element.getAttributeNames();
            for (const name of attrs) {
                if(name.slice(0,3) === "utm"){
                    var value = element.getAttribute(name);
                    utmdata += `,"${name}":"${value}"`
                }
            }

            formdata.append("props", `{"type":"Auto","guid":"${clientid.guid}","${property}":"${value}"${utmdata}}`);

            var requestOptions = {
                method: 'POST',
                body: formdata,
                redirect: 'follow'
            };


            fetch(`${domain+quoterurl+CRMURL}`,requestOptions)
                    .then((response) => response.json())
                    .then((res)=>{
                        dispatch(setField({field:"user.crmi",value:res.id}))
            });
        }
    }
}



export default fieldsMiddleware;